import * as React from "react";

import connectToList from "../../store/list";

import GenButton from "../Gen/Button";
import GenSidebarContainer from "../Gen/SidebarContainer";
import GenSidebarListControls from "../Gen/SidebarListControls";
import GenSortButtons from "../Gen/SortButtons";
import GenMore from "../Gen/More";

import CaptureSummary from "./CaptureSummary";

import useConnectedListHistory from "../../hooks/useConnectedListHistory";

interface CaptureListProps {
  documents: ConnectedList<DocumentSnakeModel>
}

function CaptureList(props: CaptureListProps) {
  const {
    documents,
  } = props;
  useConnectedListHistory("documents", documents);

  React.useEffect(() => {
    documents.mountList("/captures");
  }, []);

  return (
    <GenSidebarContainer>
      <GenSidebarListControls
        connectedList={documents}
        title="My Cases"
        search
        searchPlaceholder="Search by title, or case #..."
      >
        <GenSortButtons
          {...documents}
          sortOptions={[
            {
              "title": "Case #",
              "value": "documents.id",
            },
            {
              "title": "Published",
              "value": "documents.created_at",
            },
          ]}
        />

      </GenSidebarListControls>
      <div className="flex-grow">
        <div>
          <GenButton
            name="New Capture"
            highlighted
            href="/captures/new"
            bottom_margin
          />
        </div>
        <div>
          {
            documents.listData?.map((document) => <CaptureSummary document={document} key={document.id}/>)
          }
        </div>
        { !!documents.listData && documents.listData.length == 0 && <div key="no-items" className="gen-list-no-items"><h1>No Items</h1></div> }
        <div className="flex justify-center">
          <GenMore
            {...documents}
          />
        </div>
      </div>
    </GenSidebarContainer>
  );
}

export default connectToList(CaptureList, ["documents"]);
